
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "SystemConfiguration",
})
export default class extends Vue {}
